import React from 'react';
import PropTypes from 'prop-types';
import { Card, Row, Col, Table, Button, Icon } from 'antd';
import { stateToIconFormatter,
         stateToIconFormatterMedium,
         formaDidatticaFormatter,
         infoFormatter,
         insegnamentoFormatter,
         oreSommateFormatter,
} from 'util/Formatters.jsx';
import { registryLink } from 'util/NavigationUtils.jsx';
import ReduxAcademicYears from 'containers/fe/ReduxAcademicYears.jsx';
import { appHistory } from 'appHistory';
import { getActualAcademicYear } from 'util/AcademicYears.jsx';

const Group = Button.Group;

const columns = [
  {
    title: 'Stato',
    dataIndex: 'stato',
    className: 'text-center',
    key: 'stato',
    render: state => stateToIconFormatter(state),
  },
  {
    title: 'Insegnamento',
    dataIndex: 'descInsegnamento',
    key: 'nomeInsegnamento',
    render: (descIns, row) => insegnamentoFormatter(descIns, row),
  },
  {
    title: 'Forma Didattica',
    dataIndex: 'descFD',
    key: 'formaDid',
    render: descFD => formaDidatticaFormatter(descFD),
  },
  { title: 'Modalità di Copertura', dataIndex: 'descCopertura', key: 'codCopertura' },
  {
    title: 'Altre Informazioni',
    dataIndex: 'codAF',
    key: 'moreInfo',
    render: (codAF, row) => infoFormatter(codAF, row),
  },
  { title: 'Ore Registrate/Assegnate',
    dataIndex: 'totaliAssegnate',
    className: 'text-center',
    key: 'ore',
    render: (totaliAssegnate, row) => oreSommateFormatter(totaliAssegnate, row),
  },
];

class RegistriList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      calledWs: false,
    };
  }

  componentDidMount() {
    // getting the actual year's Educational Records
    this.props.onReceivingEduRecords(this.props.actualYear);
    // getting the critical Educational Records
    this.props.onCheckingEduRecords(getActualAcademicYear());
  }

  // parte registro trasversale, da vedere poi
  onButtonClick = () => {
    const trasversalRec = this.props.registriTrasv[0];
    const year = this.props.actualYear.substring(this.props.actualYear.length - 4);
    // controllo se l'id registro è presente, se lo è ridirigo alla pagina di
    // dettaglio, altrimenti invoco il ws di vincenzo
    if (!trasversalRec || trasversalRec.daCreare) {
      this.setState({
        calledWs: true,
      });
      // invoco action di creazione registro trasversale
      console.log('creo registro trasversale per anno ', year);
      this.props.openingTrasRecord(year)
          .then((response) => {
            console.log('stato della risposta', response);
            this.setState({
              calledWs: false,
            });
            appHistory.push(`/attivita/${response.payload[0].idRegistro}/`);
          },
                (response) => {
                  console.log('DEBUG 1 20170915: ', response);
                  // TODO: inserire notificazione di antd
                  // alert(response);
                  this.setState({
                    calledWs: false,
                  });
                });
    } else {
      console.log('apro registro trasversale numero: ', trasversalRec.idRegistro);
      appHistory.push(`/attivita/${trasversalRec.idRegistro}/`);
    }
  }

  onRegistryClick = (record) => {
    if (this.state.calledWs) { return; }
    
    if (!record.idRegistro) {
      this.setState({
        calledWs: true,
      });
      this.props.openingEduRecord(record.idCopertura)
      .then((response) => {
        record.idRegistro = response.payload.idRegistro;
        this.setState({
          calledWs: false,
        });
        registryLink(record);
      });
    } else {
      registryLink(record);
    }
  }

  render() {
    let tooltipTrasversal = 'Clicca per aprire il registro delle altre attività.';
    let status = (
      <span className="statusOpen-medium" title="Da aprire">
        <Icon type="edit" />
      </span>);
    if (this.props.registriTrasv.length !== 0) {
      console.log('sono arrivato al controllo dello stato registro trasversale',
                  this.props.registriTrasv);
      status = stateToIconFormatterMedium(this.props.registriTrasv[0].stato);
    }
    // RIMOSSO DOPO SEGNALAZIONE DI GLORIA DEL 19/10/2020
    // const toShow = (this.props.actualYear.includes('2020-2021') ? false : true);
    // console.warn ('anno attuale:', this.props.actualYear, ' controllo:', toShow);
    return (
      <Card
        title={`Registri Didattici Anno Accademico ${this.props.actualYear}`}
        className="box box-solid box-unimi"
        extra={<ReduxAcademicYears />}
      >
        <Row gutter={16}>
          <Col span={8} offset={16}>
            <Group size="large" className="float-right">
              <Button
                title={tooltipTrasversal}
                onClick={this.onButtonClick}
              >
                {status}
              </Button>
              <Button
                title={tooltipTrasversal}
                type="primary"
                onClick={this.onButtonClick}
              >
                <span className="mg2">Registro altre attività</span>
              </Button>
            </Group>
            <div className="float-right">
              <span>
                <b>Il registro delle altre attivita non deve
                  essere compilato dai professori a contratto
                </b>
              </span>
            </div>
          </Col>
        </Row>
        <Table
          rowKey="idCopertura"
          onRowClick={this.onRegistryClick}
          rowClassName="row-link"
          className="registriTable"
          columns={columns}
          dataSource={this.props.registri}
          pagination={false}
          loading={this.state.calledWs}
        />
      </Card>
      );
  }
}

RegistriList.propTypes = {
  actualYear: PropTypes.string.isRequired,
  registri: PropTypes.arrayOf(PropTypes.object).isRequired,
  registriTrasv: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool.isRequired,
  onReceivingEduRecords: PropTypes.func.isRequired,
  onCheckingEduRecords: PropTypes.func.isRequired,
  openingEduRecord: PropTypes.func,
  openingTrasRecord: PropTypes.func,
};

export { RegistriList };
